import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { connect, useSelector } from 'react-redux';

import { compose } from 'redux';
import { Satellite } from '@material-ui/icons';
import { OWNERSHIP_SEARCH } from '../../redux/panel/PanelNames';
import { visionGreen } from '../../Config/Theme/Common/Palette';

function withOwnershipSearchResults (WrappedComponent) {
    function WithOwnershipSearchResults ({activeLayers, ...otherProps}) {
        const enabled = useSelector(state => state.panels.panels[OWNERSHIP_SEARCH].enabled);
        const search = useSelector(state => state.ownershipReducer.search);
        const searchLayerId = useSelector(state => state.ownershipReducer.ownershipSearchArea.layerId);
        const searchAreaFacet = useSelector(state => state.lookups.uiData.facetChoices.find(el => el.id === state.ownershipReducer.ownershipSearchArea.facetId));
        const searchAreaFacetValue = useSelector(state => state.ownershipReducer.ownershipSearchArea.facetValue);
        const searchAreaValid = useSelector(state => state.ownershipReducer.ownershipSearchArea.facetValid);
        const layers = useSelector(state => state.layers.layers);
        const highlightedFeatures = useSelector(state => state.highlights.highlightedFeatures);

        const newActiveLayers = [...activeLayers];

        if (enabled) {
            // If search area is valid and is fixed (references a layer) then load tiles for that layer
            if (searchAreaValid && searchAreaFacet.layerType === 'fixed') {
                newActiveLayers.push({
                    uid: 'search_area_facet_' + searchAreaFacet.id,
                    systemName: searchAreaFacet.layer.systemName,
                    visible: true,
                    printable: false,
                    layerData: {
                        mvt: true,
                        url: `${searchAreaFacet.layerData.url}?value=${searchAreaFacetValue}`
                    },
                    styling: {
                        'layers': [
                            {
                                'type': 'fill',
                                'paint': {
                                    'fill-color': '#A9FE95',
                                    'fill-outline-color': '#A9FE95',
                                    'fill-opacity': 0.2

                                }
                            },
                            {
                                'type': 'line',
                                'layout': {
                                    'line-cap': 'round',
                                    'line-join': 'round'
                                },
                                'paint': {
                                    'line-color': '#A9FE95',
                                    'line-dasharray': [0.2, 2],
                                    'line-width': 4
                                }
                            }
                        ],
                        'source': {
                            'type': 'vector',
                            'maxzoom': 22,
                            'minzoom': 1
                        }
                    },
                    settings: [],
                    primaryKey: 'id',
                    highlights: []
                });
            }
            // If want to progressively show search results then need to make sure than minzoom/maxzoom update with the amount currently
            // Think those fields do not trigger a state update
            if (search && search.status === 'complete' && search.computedData && search.computedData.length > 0) {
                const layer = layers.find(layer => layer.id === searchLayerId);
                const idProperty = layer.properties.id;
                
                const polygon_point_zoom = 12;

                newActiveLayers.push({
                    uid: `search_${search.id}_polygons`,
                    systemName: layer.system_name,
                    visible: true,
                    printable: false,
                    layerData: {
                        ...search.layerData,
                        url: search.layerData.polygonUrl
                    },
                    styling: {
                        'layers': [
                            {
                                'id': `search_${search.id}_fill`,
                                'type': 'fill',
                                'source-layer': layer.system_name,
                                'paint': {
                                    'fill-color': 'transparent',
                                    'fill-opacity': 1.0
                                },
                                'maxzoom': 22,
                                'minzoom': polygon_point_zoom,
                                // 'onClick': this.viewSiteCard
                            },
                            {
                                'id': `search_${search.id}_line`,
                                'type': 'line',
                                'paint': {
                                    'line-color': '#FF0000',
                                    'line-width': 2
                                },
                                'maxzoom': 22,
                                'minzoom': polygon_point_zoom
                            }
                        ],
                        'source': {
                            'type': 'vector',
                            'maxzoom': 22,
                            'minzoom': polygon_point_zoom
                        }
                    },
                    settings: [],
                    primaryKey: layer.properties.id, 
                    highlights: highlightedFeatures.filter(e => e.layerSystemName === layer.system_name),
                });

                newActiveLayers.push({
                    uid: `search_${search.id}_points`,
                    systemName: layer.system_name,
                    visible: true,
                    printable: false,
                    layerData: {
                        ...search.layerData,
                        url: search.layerData.pointUrl
                    },
                    styling: {
                        'layers': [{
                            'id': `search_${search.id}_circle`,
                            'type': 'circle',
                            'source-layer': layer.system_name,
                            'paint': {
                                'circle-color': [
                                    "match",
                                    [
                                        "get",
                                        "proprietorship_category_aggregate"
                                    ],
                                    "Company",
                                    "rgba(164, 27, 171, 0.6)",
                                    "Corporate Body",
                                    "rgba(159, 180, 245, 0.8)",
                                    "Local/County Authority",
                                    "rgba(234, 216, 98, 0.6)",
                                    "Housing Association",
                                    "rgba(255, 4, 33, 0.6)",
                                    "rgba(255, 255, 255, 0.1)"
                                ],
                                'circle-radius': 5,
                                // TODO - Stroke should be opposite of basemap color
                                'circle-stroke-color': [
                                    "match",
                                    [
                                        "get",
                                        "proprietorship_category_aggregate"
                                    ],
                                    "Company",
                                    "#fa9cff",
                                    "Corporate Body",
                                    "#aadbfa",
                                    "Local/County Authority",
                                    "#fce8bd",
                                    "Housing Association",
                                    "#ff0421",
                                    "#f2ffff"
                                ],
                                'circle-stroke-width': 1.5
               
                            },
                            'maxzoom': polygon_point_zoom,
                            'minzoom': 1,
                            // 'onClick': this.viewSiteCard
                        }],
                        'source': {
                            'type': 'vector',
                            'maxzoom': polygon_point_zoom,
                            'minzoom': 1
                        }
                    },
                    settings: [],
                    primaryKey: layer.properties.id, 
                    highlights: highlightedFeatures.filter(e => e.layerSystemName === layer.system_name),
                });
            }
        }

        return (
            <WrappedComponent
                activeLayers={newActiveLayers}
                {...otherProps}
            />
        );
    }

    const wrappedComponentName = WrappedComponent.displayName
        || WrappedComponent.name
        || 'Component';

    WithOwnershipSearchResults.displayName = `withOwnershipSearchResults(${wrappedComponentName})`;
    return WithOwnershipSearchResults;
}

export default withOwnershipSearchResults;